import { useTranslation } from "react-i18next";
import React, { useEffect, useState, Fragment } from "react";
import {
  TextField,
  Typography,
  Hidden,
  TableCell,
  Card,
  Box,
  Container,
  TableRow,
  IconButton,
  Tooltip,
  useTheme,
  MenuItem,
} from "@mui/material"; 
import Grid from "@mui/material/Grid";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
export default function Child(props) {
  const {
    status,
    stempelpaare,
    genehmigen,
    saldo,
    index,
    aufgabe,
    zeile,
    paare,
    antragsteller,
    archiv,
    small,
    zaaktiv,
    zeitarten,
  } = props;
  const [item, setItem] = useState(props.zeile);
  const theme = useTheme();
  const { t } = useTranslation();
  useEffect(() => {
    // eslint-disable-next-line
  }, [props]);
  useEffect(() => {
    setItem(zeile);
    // eslint-disable-next-line
  }, [zeile]);
  const onChange = (event, feld) => {
    let newValue = event.target.value;
    var zusatz = checkZusatz(newValue, feld);
    setItem((prevState) => {
      let newItem = { ...prevState };
      newItem[feld] = newValue;
      newItem.zusatz = zusatz;
      // sync with [arent array]
      props.onChange(props.index, newItem);
      return newItem;
    });
  };
  function checkZusatz(val, feld) {
    var zusatz = "";
    var szk1 = feld === "szk1" ? val : item.szk1;
    var szg1 = feld === "szg1" ? val : item.szg1;
    var szk2 = feld === "szk2" ? val : item.szk2;
    var szg2 = feld === "szg2" ? val : item.szg2;
    var szk3 = feld === "szk3" ? val : item.szk3;
    var szg3 = feld === "szg3" ? val : item.szg3;

    if (
      (!szk1 || Number(szk1) === 0 || szk1 === "" || szk1 === "00:00") &&
      (!szg1 || Number(szg1) === 0 || szg1 === "" || szg1 === "00:00")
    ) {
      return "";
    }
    zusatz = szk1 + " - " + szg1;
    if (
      (!szk2 || Number(szk2) === 0 || szk2 === "" || szk2 === "00:00") &&
      (!szg2 || Number(szg2) === 0 || szg2 === "" || szg2 === "00:00") &&
      (!szk3 || Number(szk3) === 0 || szk3 === "" || szk3 === "00:00") &&
      (!szg3 || Number(szg3) === 0 || szg3 === "" || szg3 === "00:00")
    ) {
      return zusatz;
    } else {
      return zusatz + " (...)";
    }
  }
  const Add = () => {
    props.add();
  };
  const Del = () => {
    props.del();
  };
  const onClick = (index) => {
    props.onClick(index);
  };
  const tableRowStyle = () => {
    if (
      item.gesperrt &&
      item.gesperrt === "1" &&
      item.sperrgrund &&
      item.sperrgrund !== ""
    ) {
      return small
        ? { cursor: "pointer", backgroundColor: "rgba(190,190,200,0.5)" }
        : { backgroundColor: "rgba(190,190,200,0.5)" };
    }
    return small ? { cursor: "pointer" } : {};
  };
  const tableChipStyle = (red, green, blue) => {
    if (red) {
      return { backgroundColor: `rgba(${red},${green},${blue},0.5)` };
    } else {
      return {};
    }
  };

  return (
    <Fragment>
      {aufgabe === "alles" && (
        <TableRow
          key={"zeile" + index}
          style={tableRowStyle()}
          onClick={() =>
            small &&
            (item.gesperrt !== "1" || (status !== "O" && status !== "A"))
              ? onClick(index)
              : {}
          }
          hover={
            small &&
            (item.gesperrt !== "1" || (status !== "O" && status !== "A"))
          }
        >
          <Hidden lgUp>
            <TableCell align="left">
              <Grid container>
                <Grid item xs={6}>
                  <div style={{ fontWeight: "700" }}>{item.datum}</div>
                </Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={4} align="left">
                  {((genehmigen === "1" && saldo === "0") || saldo === "2") &&
                    "Saldo: " + item.saldo}
                </Grid>

                {item.info2 && item.info2 !== "" && (
                  <Grid item xs={12}>
                    <div
                      style={
                        item.red2
                          ? tableChipStyle(item.red2, item.green2, item.blue2)
                          : {
                              backgroundColor: `rgba(${"255"},${"255"},${"255"},0)`,
                            }
                      }
                    >
                      {item.info2}
                    </div>
                  </Grid>
                )}
                {item.zusatz && item.zusatz !== "" && (
                  <Grid item xs={12}>
                    <div>
                      {item.zusatz && item.zusatz !== "" ? item.zusatz : "-"}
                    </div>
                  </Grid>
                )}
                {(!item.zusatz || item.zusatz === "") &&
                  (!item.info2 || item.info2 === "") && (
                    <Grid item xs={12}>
                      <div>-</div>
                    </Grid>
                  )}
              </Grid>
            </TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>
              <Container>
                <Typography component="div">{item.datum}</Typography>
              </Container>
            </TableCell>
            <Hidden lgDown>
              <TableCell align="center">
                {item.info && item.info !== "" && (
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      style={
                        item.red
                          ? tableChipStyle(item.red, item.green, item.blue)
                          : {
                              backgroundColor: `rgba(${"255"},${"255"},${"255"},0)`,
                            }
                      }
                    >
                      <Typography fulLWidth>{item.info}</Typography>
                    </Grid>
                  </Grid>
                )}
              </TableCell>
            </Hidden>
            <Hidden lgUp>
              <TableCell align="center">
                <Container>
                  {item.info2 && item.info2 !== "" && (
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        style={
                          item.red2
                            ? tableChipStyle(item.red2, item.green2, item.blue2)
                            : {
                                backgroundColor: `rgba(${"255"},${"255"},${"255"},0)`,
                              }
                        }
                      >
                        <Typography fulLWidth>{item.info2}</Typography>
                      </Grid>
                    </Grid>
                  )}
                </Container>
              </TableCell>
            </Hidden>
            {((genehmigen === "1" && saldo === "0") || saldo === "2") && (
              <TableCell align="center">
                <Container>
                  <Typography component="div">{item.saldo}</Typography>
                </Container>
              </TableCell>
            )}
            {(genehmigen === "1" || status === "A" || status === "N") && (
              <Hidden lgDown>
                <TableCell align="center">
                  <Tooltip title={item.hinweisvg}>
                    <TextField
                      id={"hinweisvg" + index}
                      disabled={genehmigen !== "1"}
                      value={item.hinweisvg}
                      onChange={(e) => onChange(e, "hinweisvg")}
                      variant="outlined"
                      size="small"
                      style={
                        genehmigen === "1"
                          ? { backgroundColor: theme.palette.blocks.hyellow }
                          : {}
                      }
                    />
                  </Tooltip>
                </TableCell>
              </Hidden>
            )}
            <Hidden lgDown>
              <TableCell align="center">
                <Tooltip title={item.hinweisan}>
                  <TextField
                    id={"hinweisan" + index}
                    disabled={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                    }
                    value={item.hinweisan}
                    onChange={(e) => onChange(e, "hinweisan")}
                    variant="outlined"
                    size="small"
                  />
                </Tooltip>
              </TableCell>
            </Hidden>
            <Hidden lgDown>
              <TableCell align="center">
                <TextField
                  id={"szk1" + index}
                  disabled={
                    (status !== "O" && status !== "A") || item.gesperrt === "1"
                  }
                  value={item.szk1}
                  type="time"
                  onChange={(e) => onChange(e, "szk1")}
                  variant="outlined"
                  size="small"
                />
              </TableCell>
            </Hidden>
            <Hidden lgDown>
              <TableCell align="center">
                <TextField
                  id={"szg1" + index}
                  disabled={
                    (status !== "O" && status !== "A") || item.gesperrt === "1"
                  }
                  value={item.szg1}
                  type="time"
                  onChange={(e) => onChange(e, "szg1")}
                  variant="outlined"
                  size="small"
                />
              </TableCell>
            </Hidden>
            {zaaktiv === "1" && (
              <Hidden lgDown>
                <TableCell align="center">
                  <TextField
                    id={"za1" + index}
                    disabled={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                    }
                    value={item.za1}
                    variant="outlined"
                    size="small"
                    select
                    fullWidth
                    onChange={(e) => onChange(e, "za1")}
                  >
                    {zeitarten &&
                      zeitarten.map((item, index) => (
                        <MenuItem key={item.key} value={item.key}>
                          {item.bez}
                        </MenuItem>
                      ))}
                  </TextField>
                </TableCell>
              </Hidden>
            )}
            {paare >= 2 && (
              <Hidden lgDown>
                <TableCell align="center">
                  <TextField
                    id={"szk2" + index}
                    disabled={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                    }
                    value={item.szk2}
                    type="time"
                    onChange={(e) => onChange(e, "szk2")}
                    variant="outlined"
                    size="small"
                  />
                </TableCell>
              </Hidden>
            )}
            {paare >= 2 && (
              <Hidden lgDown>
                <TableCell align="center">
                  <TextField
                    id={"szg2" + index}
                    disabled={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                    }
                    value={item.szg2}
                    type="time"
                    onChange={(e) => onChange(e, "szg2")}
                    variant="outlined"
                    size="small"
                  />
                </TableCell>
              </Hidden>
            )}
            {paare >= 2 && zaaktiv === "1" && (
              <Hidden lgDown>
                <TableCell align="center">
                  <TextField
                    id={"za2" + index}
                    disabled={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                    }
                    value={item.za2}
                    variant="outlined"
                    size="small"
                    select
                    fullWidth
                    onChange={(e) => onChange(e, "za2")}
                  >
                    {zeitarten &&
                      zeitarten.map((item, index) => (
                        <MenuItem key={item.key} value={item.key}>
                          {item.bez}
                        </MenuItem>
                      ))}
                  </TextField>
                </TableCell>
              </Hidden>
            )}
            {paare >= 3 && (
              <Hidden lgDown>
                <TableCell align="center">
                  <TextField
                    id={"szk3" + index}
                    disabled={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                    }
                    value={item.szk3}
                    type="time"
                    onChange={(e) => onChange(e, "szk3")}
                    variant="outlined"
                    size="small"
                  />
                </TableCell>
              </Hidden>
            )}
            {paare >= 3 && (
              <Hidden lgDown>
                <TableCell align="center">
                  <TextField
                    id={"szg3" + index}
                    disabled={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                    }
                    value={item.szg3}
                    type="time"
                    onChange={(e) => onChange(e, "szg3")}
                    variant="outlined"
                    size="small"
                  />
                </TableCell>
              </Hidden>
            )}
            {paare >= 3 && zaaktiv === "1" && (
              <Hidden lgDown>
                <TableCell align="center">
                  <TextField
                    id={"za3" + index}
                    disabled={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                    }
                    value={item.za3}
                    variant="outlined"
                    size="small"
                    select
                    fullWidth
                    onChange={(e) => onChange(e, "za3")}
                  >
                    {zeitarten &&
                      zeitarten.map((item, index) => (
                        <MenuItem key={item.key} value={item.key}>
                          {item.bez}
                        </MenuItem>
                      ))}
                  </TextField>
                </TableCell>
              </Hidden>
            )}
            {stempelpaare >= 4 && paare >= 4 && (
              <Hidden lgDown>
                <TableCell align="center">
                  <TextField
                    id={"szk4" + index}
                    disabled={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                    }
                    value={item.szk4}
                    type="time"
                    onChange={(e) => onChange(e, "szk4")}
                    variant="outlined"
                    size="small"
                  />
                </TableCell>
              </Hidden>
            )}
            {stempelpaare >= 4 && paare >= 4 && (
              <Hidden lgDown>
                <TableCell align="center">
                  <TextField
                    id={"szg4" + index}
                    disabled={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                    }
                    value={item.szg4}
                    type="time"
                    onChange={(e) => onChange(e, "szg4")}
                    variant="outlined"
                    size="small"
                  />
                </TableCell>
              </Hidden>
            )}
            {stempelpaare >= 4 && paare >= 4 && zaaktiv === "1" && (
              <Hidden lgDown>
                <TableCell align="center">
                  <TextField
                    id={"za4" + index}
                    disabled={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                    }
                    value={item.za4}
                    variant="outlined"
                    size="small"
                    select
                    fullWidth
                    onChange={(e) => onChange(e, "za4")}
                  >
                    {zeitarten &&
                      zeitarten.map((item, index) => (
                        <MenuItem key={item.key} value={item.key}>
                          {item.bez}
                        </MenuItem>
                      ))}
                  </TextField>
                </TableCell>
              </Hidden>
            )}
            {stempelpaare >= 5 && paare >= 5 && (
              <Hidden lgDown>
                <TableCell align="center">
                  <TextField
                    id={"szk5" + index}
                    disabled={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                    }
                    value={item.szk5}
                    type="time"
                    onChange={(e) => onChange(e, "szk5")}
                    variant="outlined"
                    size="small"
                  />
                </TableCell>
              </Hidden>
            )}
            {stempelpaare >= 5 && paare >= 5 && (
              <Hidden lgDown>
                <TableCell align="center">
                  <TextField
                    id={"szg5" + index}
                    disabled={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                    }
                    value={item.szg5}
                    type="time"
                    onChange={(e) => onChange(e, "szg5")}
                    variant="outlined"
                    size="small"
                  />
                </TableCell>
              </Hidden>
            )}
            {stempelpaare >= 5 && paare >= 5 && zaaktiv === "1" && (
              <Hidden lgDown>
                <TableCell align="center">
                  <TextField
                    id={"za5" + index}
                    disabled={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                    }
                    value={item.za5}
                    variant="outlined"
                    size="small"
                    select
                    fullWidth
                    onChange={(e) => onChange(e, "za5")}
                  >
                    {zeitarten &&
                      zeitarten.map((item, index) => (
                        <MenuItem key={item.key} value={item.key}>
                          {item.bez}
                        </MenuItem>
                      ))}
                  </TextField>
                </TableCell>
              </Hidden>
            )}
          </Hidden>
        </TableRow>
      )}
      {aufgabe === "zeile" && (
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="flex-end"
        >
          <Grid item xs={12}>
            {genehmigen === "1" && (
              <Grid
                container
                justifyContent="center"
                alignItems="flex-end"
                spacing={2}
              >
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="annr"
                    label={t("Antragsteller")}
                    fullWidth
                    disabled
                    value={antragsteller}
                    variant="filled"
                  />
                </Grid>
              </Grid>
            )}
            <Grid
              container
              justifyContent="center"
              alignItems="flex-end"
              spacing={2}
            >
              <Grid item xs={12} sm={6}>
                <TextField
                  id={"datum"}
                  disabled
                  value={item.datum}
                  variant="filled"
                  fullWidth
                  label={t("Datum")}
                />
              </Grid>
            </Grid>
            {item.info !== "" && item.info !== null && (
              <Grid
                container
                justifyContent="center"
                alignItems="flex-end"
                spacing={2}
              >
                <Grid item xs={12} sm={6}>
                  <TextField
                    id={"info"}
                    disabled
                    value={item.info}
                    variant="filled"
                    fullWidth
                    label={t("Info")}
                    style={
                      item.red && {
                        backgroundColor: `rgba(${item.red},${item.green},${item.blue},0.5)`,
                      }
                    }
                  />
                </Grid>
              </Grid>
            )}
            {((genehmigen === "1" && saldo === "0") || saldo === "2") && (
              <Grid
                container
                justifyContent="center"
                alignItems="flex-end"
                spacing={2}
              >
                <Grid item xs={12} sm={6}>
                  <TextField
                    id={"saldo"}
                    disabled
                    fullWidth
                    value={item.saldo}
                    variant="filled"
                    label="+/-"
                  />
                </Grid>
              </Grid>
            )}
            {(genehmigen === "1" || status === "A" || status === "N") && (
              <Grid
                container
                justifyContent="center"
                alignItems="flex-end"
                spacing={2}
              >
                <Grid item xs={12} sm={6}>
                  <TextField
                    id={"hinweisvg"}
                    disabled={genehmigen !== "1"}
                    value={item.hinweisvg}
                    fullWidth
                    onChange={(e) => onChange(e, "hinweisvg")}
                    variant={genehmigen !== "1" ? "filled" : "outlined"}
                    style={
                      genehmigen === "1"
                        ? { backgroundColor: theme.palette.blocks.hyellow }
                        : {}
                    }
                    label={t("Kommentar Vorgesetzter")}
                    multiline
                  />
                </Grid>
              </Grid>
            )}
            <Grid
              container
              justifyContent="center"
              alignItems="flex-end"
              spacing={2}
            >
              <Grid item xs={12} sm={6}>
                <TextField
                  id={"hinweisan"}
                  disabled={
                    (status !== "O" && status !== "A") || item.gesperrt === "1"
                  }
                  value={item.hinweisan}
                  onChange={(e) => onChange(e, "hinweisan")}
                  variant={
                    (status !== "O" && status !== "A") || item.gesperrt === "1"
                      ? "filled"
                      : "outlined"
                  }
                  label={t("Kommentar")}
                  fullWidth
                  multiline
                />
              </Grid>
            </Grid>
            {archiv !== "J" && (status === "O" || status === "A") && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Card>
                    <Box p={1}>
                      <Grid
                        container
                        spacing={1}
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Grid item xs={2}>
                          {paare > 1 && (
                            <IconButton
                              variant="contained"
                              color="primary"
                              onClick={() => {
                                Del();
                              }}
                            >
                              <RemoveIcon fontSize="large" />
                            </IconButton>
                          )}
                        </Grid>
                        <Grid item xs={8}>
                          <TextField
                            size="small"
                            id="timepairs"
                            label={t("Anzahl Zeitpaare")}
                            fullWidth
                            variant="filled"
                            color="primary"
                            disabled
                            value={paare.toString()}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          {paare < Math.max(stempelpaare, 3) && (
                            <IconButton
                              variant="contained"
                              color="primary"
                              onClick={() => {
                                Add();
                              }}
                            >
                              <AddIcon fontSize="large" />
                            </IconButton>
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  </Card>
                </Grid>
              </Grid>
            )}
            <Box pt={2}>
              <Grid
                container
                justifyContent="center"
                alignItems="flex-end"
                spacing={2}
              >
                <Grid item xs={12} sm={zaaktiv === "1" ? 4 : 6}>
                  <TextField
                    id={"szk1"}
                    disabled={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                    }
                    value={item.szk1}
                    type="time"
                    fullWidth
                    label={t("Kommt Zeit 1")}
                    onChange={(e) => onChange(e, "szk1")}
                    variant={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                        ? "filled"
                        : "outlined"
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={zaaktiv === "1" ? 4 : 6}>
                  <TextField
                    id={"szg1"}
                    disabled={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                    }
                    value={item.szg1}
                    type="time"
                    fullWidth
                    label={t("Geht Zeit 1")}
                    onChange={(e) => onChange(e, "szg1")}
                    variant={
                      (status !== "O" && status !== "A") ||
                      item.gesperrt === "1"
                        ? "filled"
                        : "outlined"
                    }
                  />
                </Grid>
                {zaaktiv === "1" && (
                  <Grid item xs={12} sm={4}>
                    <TextField
                      id={"za1"}
                      disabled={
                        (status !== "O" && status !== "A") ||
                        item.gesperrt === "1"
                      }
                      value={item.za1}
                      variant="outlined"
                      select
                      label={t("Zeitart 1")}
                      fullWidth
                      onChange={(e) => onChange(e, "za1")}
                    >
                      {zeitarten &&
                        zeitarten.map((item, index) => (
                          <MenuItem key={item.key} value={item.key}>
                            {item.bez}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>
                )}
                {paare >= 2 && (
                  <>
                    <Grid item xs={12} sm={zaaktiv === "1" ? 4 : 6}>
                      <TextField
                        id={"szk2"}
                        disabled={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1"
                        }
                        value={item.szk2}
                        type="time"
                        fullWidth
                        label={t("Kommt Zeit 2")}
                        onChange={(e) => onChange(e, "szk2")}
                        variant={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1"
                            ? "filled"
                            : "outlined"
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={zaaktiv === "1" ? 4 : 6}>
                      <TextField
                        id={"szg2"}
                        disabled={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1"
                        }
                        value={item.szg2}
                        type="time"
                        fullWidth
                        label={t("Geht Zeit 2")}
                        onChange={(e) => onChange(e, "szg2")}
                        variant={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1"
                            ? "filled"
                            : "outlined"
                        }
                      />
                    </Grid>
                    {zaaktiv === "1" && (
                      <Grid item xs={12} sm={4}>
                        <TextField
                          id={"za22"}
                          disabled={
                            (status !== "O" && status !== "A") ||
                            item.gesperrt === "1"
                          }
                          value={item.za2}
                          variant="outlined"
                          select
                          label={t("Zeitart 1")}
                          fullWidth
                          onChange={(e) => onChange(e, "za2")}
                        >
                          {zeitarten &&
                            zeitarten.map((item, index) => (
                              <MenuItem key={item.key} value={item.key}>
                                {item.bez}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                    )}
                  </>
                )}
                {paare >= 3 && (
                  <>
                    <Grid item xs={12} sm={zaaktiv === "1" ? 4 : 6}>
                      <TextField
                        id={"szk3"}
                        disabled={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1"
                        }
                        value={item.szk3}
                        type="time"
                        fullWidth
                        label={t("Kommt Zeit 3")}
                        onChange={(e) => onChange(e, "szk3")}
                        variant={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1"
                            ? "filled"
                            : "outlined"
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={zaaktiv === "1" ? 4 : 6}>
                      <TextField
                        id={"szg3"}
                        disabled={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1"
                        }
                        value={item.szg3}
                        type="time"
                        fullWidth
                        label={t("Geht Zeit 3")}
                        onChange={(e) => onChange(e, "szg3")}
                        variant={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1"
                            ? "filled"
                            : "outlined"
                        }
                      />
                    </Grid>
                    {zaaktiv === "1" && (
                      <Grid item xs={12} sm={4}>
                        <TextField
                          id={"za3"}
                          disabled={
                            (status !== "O" && status !== "A") ||
                            item.gesperrt === "1"
                          }
                          value={item.za3}
                          variant="outlined"
                          select
                          label={t("Zeitart 1")}
                          fullWidth
                          onChange={(e) => onChange(e, "za3")}
                        >
                          {zeitarten &&
                            zeitarten.map((item, index) => (
                              <MenuItem key={item.key} value={item.key}>
                                {item.bez}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                    )}
                  </>
                )}
                {stempelpaare >= 4 && paare >= 4 && (
                  <>
                    <Grid item xs={12} sm={zaaktiv === "1" ? 4 : 6}>
                      <TextField
                        id={"szk4"}
                        disabled={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1"
                        }
                        value={item.szk4}
                        type="time"
                        fullWidth
                        label={t("Kommt Zeit 4")}
                        onChange={(e) => onChange(e, "szk4")}
                        variant={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1"
                            ? "filled"
                            : "outlined"
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={zaaktiv === "1" ? 4 : 6}>
                      <TextField
                        id={"zsg4"}
                        disabled={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1"
                        }
                        value={item.szg4}
                        type="time"
                        fullWidth
                        label={t("Geht Zeit 4")}
                        onChange={(e) => onChange(e, "szg4")}
                        variant={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1"
                            ? "filled"
                            : "outlined"
                        }
                      />
                    </Grid>
                    {zaaktiv === "1" && (
                      <Grid item xs={12} sm={4}>
                        <TextField
                          id={"za4"}
                          disabled={
                            (status !== "O" && status !== "A") ||
                            item.gesperrt === "1"
                          }
                          value={item.za4}
                          variant="outlined"
                          select
                          label={t("Zeitart 4")}
                          fullWidth
                          onChange={(e) => onChange(e, "za1")}
                        >
                          {zeitarten &&
                            zeitarten.map((item, index) => (
                              <MenuItem key={item.key} value={item.key}>
                                {item.bez}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                    )}
                  </>
                )}
                {stempelpaare >= 5 && paare >= 5 && (
                  <>
                    <Grid item xs={12} sm={zaaktiv === "1" ? 4 : 6}>
                      <TextField
                        id={"szk5"}
                        disabled={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1"
                        }
                        value={item.szk5}
                        type="time"
                        fullWidth
                        label={t("Kommt Zeit 5")}
                        onChange={(e) => onChange(e, "szk5")}
                        variant={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1"
                            ? "filled"
                            : "outlined"
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={zaaktiv === "1" ? 4 : 6}>
                      <TextField
                        id={"szg5"}
                        disabled={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1"
                        }
                        value={item.szg5}
                        type="time"
                        fullWidth
                        label={t("Geht Zeit 5")}
                        onChange={(e) => onChange(e, "szg5")}
                        variant={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1"
                            ? "filled"
                            : "outlined"
                        }
                      />
                    </Grid>
                    {zaaktiv === "1" && (
                      <Grid item xs={12} sm={4}>
                        <TextField
                          id={"za5"}
                          disabled={
                            (status !== "O" && status !== "A") ||
                            item.gesperrt === "1"
                          }
                          value={item.za5}
                          variant="outlined"
                          select
                          label={t("Zeitart 5")}
                          fullWidth
                          onChange={(e) => onChange(e, "za1")}
                        >
                          {zeitarten &&
                            zeitarten.map((item, index) => (
                              <MenuItem key={item.key} value={item.key}>
                                {item.bez}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                    )}
                  </>
                )}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      )}
    </Fragment>
  );
}
